import React from "react";
import { Box, Typography, Button, Chip, Stack } from "@mui/material";
import { motion } from "framer-motion";
import { ARCADE_ACCENT } from "../../utils/triviaArcade";

const formatDailyDate = (dateString) => {
  if (!dateString) return "Today";
  const date = new Date(`${dateString}T00:00:00Z`);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const TriviaDailyHero = ({
  date,
  played,
  userScore,
  participantCount,
  onPlay,
  onViewLeaderboard,
  reducedMotion,
}) => {
  const label = `${formatDailyDate(date)} Daily`;

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        mb: 3,
        background:
          "linear-gradient(135deg, rgba(26,26,46,0.95) 0%, rgba(236,72,153,0.18) 100%)",
        border: "1px solid rgba(236,72,153,0.25)",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Chip label={label} sx={{ fontWeight: 700 }} />
        {participantCount != null && (
          <Typography variant="body2" color="text.secondary">
            {participantCount.toLocaleString()} played today
          </Typography>
        )}
      </Stack>

      <Typography variant="h4" fontWeight={800} sx={{ mb: 1 }}>
        Daily Challenge
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        10 questions · Same for everyone · Medium difficulty
      </Typography>

      {played ? (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
          <Chip label={`Your score: ${userScore}`} color="success" />
          <Button variant="outlined" onClick={onViewLeaderboard}>
            View leaderboard
          </Button>
          <Button variant="contained" disabled>
            Completed ✓
          </Button>
        </Stack>
      ) : (
        <motion.div
          animate={
            reducedMotion
              ? undefined
              : { scale: [1, 1.03, 1], opacity: [1, 0.92, 1] }
          }
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ display: "inline-block" }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={onPlay}
            sx={{ bgcolor: ARCADE_ACCENT, "&:hover": { bgcolor: "#db2777" } }}
          >
            Play Daily
          </Button>
        </motion.div>
      )}
    </Box>
  );
};

export default TriviaDailyHero;
